import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OauthService } from '../../../services/oauth/oauth.service';
import { OAuthToken } from '../../models/OAuthToken';
import { BypassAssetsInterceptor } from '../bypass-assets/bypass.assets.interceptor';


const VALIDATEPATH = '/user/v2/login';
/**
 * Adds API gateway OAuth token into request headers.
 */
@Injectable({
  providedIn: 'root'
})
export class OauthInterceptor extends BypassAssetsInterceptor implements HttpInterceptor {

  private readonly CLIENT_ID: string = 'WPRO';
  private readonly CLIENT_ID_WCDO: string = 'WCDO';

  constructor(private oauthService: OauthService) {
    super();
  }

  /**
   * Adds oauth authorization headers into endpoint requests.
   *
   * Do not intercept {@link OauthService} requests to prevent infinite call stack!
   */
   interceptInternal(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const reqUrl = req.url ?? '';
    const pathname = reqUrl.split('.com')[1];
    let clientId = '';
    if (pathname) {
      clientId = (pathname.indexOf(VALIDATEPATH) > -1) ? this.CLIENT_ID_WCDO : this.CLIENT_ID;
    }
    let headers = req.headers
      .set('Content-Type', 'application/json')
      .set('X-clientid', clientId || this.CLIENT_ID)
      .set('X-loggedin', 'true')
      .set('X-version', '1.0');
    if (reqUrl.includes('adminCal')) {
      return next.handle(req.clone({ headers }));
    } else {
      const oauthTokenSource = this.oauthService.readOauthToken$();
      const interceptSource = (token: OAuthToken) => {
        headers = headers.set('Authorization', `${token.token_type} ${token.access_token}`);
        return next.handle(req.clone({ headers }));
      };
      return oauthTokenSource.pipe(switchMap(interceptSource));
    }
  }

}
